import { Injectable, inject } from '@angular/core';
import { firstValueFrom, timeout, TimeoutError } from 'rxjs';
import { ApiService } from './api.service';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class InoutService {
  private api = inject(ApiService);

  get(id = 'self', year = 'all', month = 'all'): Promise<any> {
    return this.api.get(`/member/${id}/inout/${year}/${month}`);
  }

  async getQR(uuid: string, isEntry = 0): Promise<any> {
    try {
      const res = await firstValueFrom(this.api.getRaw<any>(`/inout/qr/${uuid}/${isEntry}`).pipe(timeout(environment.timeout)));
      if (res?.success !== true) return res?.error ?? res;
      return res.result;
    } catch (err: any) {
      if (err instanceof TimeoutError) throw new Error('通信がタイムアウトしました。しばらくしてから再度お試しください。');
      if (err?.status === 401) throw err;
      if (err?.status !== 500) {
        const body = err?.error;
        // Keep the HTTP status for QR diagnostics when unwrapping the API body.
        return body && typeof body === 'object'
          ? { ...body, status: err?.status }
          : { error: body ?? err?.message, status: err?.status };
      }
      this.api.getRouter().navigate(['/error']);
      throw err;
    }
  }

  async isConfiguredQr(): Promise<boolean> {
    try {
      const res = await firstValueFrom(this.api.getRaw<any>('/inout/qr/is_configured').pipe(timeout(environment.timeout)));
      return !!res?.result;
    } catch {
      return false;
    }
  }
}
